import { render, staticRenderFns } from "./ProjectTypeUTC.vue?vue&type=template&id=be9fa516&scoped=true&"
import script from "./ProjectTypeUTC.vue?vue&type=script&lang=js&"
export * from "./ProjectTypeUTC.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTypeUTC.vue?vue&type=style&index=0&id=be9fa516&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9fa516",
  null
  
)

export default component.exports